import { keyframes as o } from "styled-components";
const n = o`
0% {
  background-color: hsl(200, 20%, 80%);
}
100% {
  background-color: hsl(200, 20%, 95%);
}
`;
export {
  n as skeletonLoadingAnimation
};
//# sourceMappingURL=style.js.map
